import { FormattedMessage } from "react-intl";
import { redirect } from 'react-router-dom';

import { createRoutes } from "./navigationContext";

export function createBotDetailsRoutes() {
  const routes = createRoutes({
    layout: async () => {
      const { BotDetailsLayout } = await import("./layout");
      return <BotDetailsLayout />;
    },
    routes: [
      {
        path: 'configure',
        data: {
          title: <FormattedMessage defaultMessage="Configure" description="Navigation menu title for bot configuration page" />,
        },
        page: async () => {
          const { BotConfigure } = await import("./pages/BotConfigure");
          return <BotConfigure />;
        }
      },
      {
        path: 'channels',
        data: {
          title: <FormattedMessage defaultMessage="Channels" description="Navigation menu title for bot channels configuration page" />,
        },
        page: async () => {
          const { BotChannels } = await import("./pages/BotChannels");
          return <BotChannels />;
        }
      },
      {
        path: 'events',
        data: {
          title: <FormattedMessage defaultMessage="Meeting event subscriptions" description="Navigation menu title for bot event configuration page" />,
        },
        page: async () => {
          const { BotEventSubscriptionPage } = await import("./pages/BotEventSubscription");
          return <BotEventSubscriptionPage />;
        }
      }
    ]
  });
  const children = [
    ...routes,
    // add this rediction route to get the bare path and move it to /configure
    {
      path: '',
      loader: () => {
        return redirect('configure');
      }
    }
  ]
  return [
    {
      path: ':botId',
      children,
    }
  ]
}
